@import '../../utils/global.module.less';

.taskPageDropZone {
    border: 2px solid transparent;

    &[class*='dz-drag-hover'] {
        animation: scaleInOut 0.75s ease-in-out;
    }

    *[class*='dz-message'] {
        margin: 0 !important;
    }

    border-radius: 10px;
}
